import { namespacedClassnames } from '../../common';
import * as React from 'react';
export var Icon = function (props) {
    var html = { __html: props.icon };
    var className = namespacedClassnames('icon', 'svg-icon', props.className);
    return (React.createElement("span", { className: className, dangerouslySetInnerHTML: html }));
};
//# sourceMappingURL=icon.js.map